import { getFromLocalStorage } from "../libs/helpers/localstorage";

/**
 * Builds fetch options with authentication headers
 * This centralizes the common logic for token and tenant handling
 *
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, etc.)
 * @param {Object} data - Optional data to send in the request body
 * @param {Object} additionalHeaders - Optional additional headers to merge
 * @returns {Object} Fetch options object with headers and body
 */
export const buildFetchOptions = (
  method = "GET",
  data = null,
  additionalHeaders = {},
) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacTenant")?.data;
  const token = ls && ls.token;

  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant": tenant,
      ...additionalHeaders,
    },
  };

  if (data && (method === "POST" || method === "PUT" || method === "PATCH")) {
    options.body = JSON.stringify(data);
  }

  return options;
};

/**
 * Builds axios config with authentication headers
 * This centralizes the common logic for token and tenant handling
 *
 * @param {Object} additionalHeaders - Optional additional headers to merge
 * @returns {Object} Axios config object with headers
 */
export const buildAxiosConfig = (additionalHeaders = {}) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacTenant")?.data;
  const token = ls && ls.token;

  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant": tenant,
      ...additionalHeaders,
    },
  };
};
